import { postOrderStatusMultiple } from '../../services/api/order.api';
import {
	POST_ORDER_STATUS_MULTIPLE_REQUEST,
	POST_ORDER_STATUS_MULTIPLE_SUCCESS,
	POST_ORDER_STATUS_MULTIPLE_FAILURE,
} from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[POST_ORDER_STATUS_MULTIPLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_ORDER_STATUS_MULTIPLE_SUCCESS](state) {
			state.isLoading = false;
		},
		[POST_ORDER_STATUS_MULTIPLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateOrderStatusMultiple({ commit }, params) {
			try {
				commit(POST_ORDER_STATUS_MULTIPLE_REQUEST);
				await postOrderStatusMultiple(params);
				commit(POST_ORDER_STATUS_MULTIPLE_SUCCESS);
			} catch (error) {
				commit(POST_ORDER_STATUS_MULTIPLE_FAILURE, error);
			}
		},
	},
};